import { render, staticRenderFns } from "./candidate_years_experience.vue?vue&type=template&id=8df395d0&scoped=true&"
import script from "./candidate_years_experience.vue?vue&type=script&lang=js&"
export * from "./candidate_years_experience.vue?vue&type=script&lang=js&"
import style0 from "./candidate_years_experience.vue?vue&type=style&index=0&id=8df395d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df395d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8df395d0')) {
      api.createRecord('8df395d0', component.options)
    } else {
      api.reload('8df395d0', component.options)
    }
    module.hot.accept("./candidate_years_experience.vue?vue&type=template&id=8df395d0&scoped=true&", function () {
      api.rerender('8df395d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/metrics/candidate_years_experience.vue"
export default component.exports